export default __webpack_public_path__ + "static/media/edit-icon.17419d8b.png";